// extracted by mini-css-extract-plugin
export default {"title":"RadioGroupWithSubtitle_title__QzJad","subTitle":"RadioGroupWithSubtitle_subTitle__etuVI","bulletPointTopAligned":"RadioGroupWithSubtitle_bulletPointTopAligned__RIuvd"};